import { Box, Container, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ManagementActivities from '../components/management/ManagementActivities';
import ManagementFindings from '../components/management/ManagementFindings';
import { LoadStatus } from '../constants/constants';
import { selectFindingLoadStatus } from '../redux/reducers/findingsReducer';
import LoadingIndicator from '../components/LoadingIndicator';
import { selectActivityLoadStatus } from '../redux/reducers/activityReducer';
import logo from '../assets/images/manage-activities-blue.svg';

function ManageActivitiesView() {
  const { t } = useTranslation();
  const findingsLoadStatus = useSelector(selectFindingLoadStatus);
  const activityLoadStatus = useSelector(selectActivityLoadStatus);

  const TabValues = Object.freeze({
    ACTIVITIES: 'activities',
    FINDINGS: 'findings',
    valueOf(index) {
      switch (index) {
        case 1:
          return TabValues.FINDINGS;
        case 0:
        default:
          return TabValues.ACTIVITIES;
      }
    },
    indexOf(value) {
      switch (value) {
        case TabValues.FINDINGS:
          return 1;
        case TabValues.ACTIVITIES:
        default:
          return 0;
      }
    },
  });

  const [selectedTab, setSelectedTab] = useState(TabValues.ACTIVITIES);

  const handleChange = (_, index) => {
    setSelectedTab(TabValues.valueOf(index));
  };

  function renderTabContents(tab) {
    switch (tab) {
      case TabValues.FINDINGS:
        return <ManagementFindings />;
      case TabValues.ACTIVITIES: // Intentional fallthrough
      default:
        return <ManagementActivities />;
    }
  }

  return (
    <Container variant="baseView" subtype="activityManagement" maxWidth={false} disableGutters>
      <Stack sx={{ mb: 3 }} direction="row" variant="assessmentHeader" useFlexGap>
        <img src={logo} />
        <Typography variant="title">{t('activityManagement.title')}</Typography>
      </Stack>
      <Stack spacing={2} sx={{ maxWidth: 'lg' }}>
        <Typography variant="regular">{t('activityManagement.description')}</Typography>
        <Typography variant="regular">{t('activityManagement.descriptionFinding')}</Typography>
      </Stack>
      <Tabs
        sx={{ maxWidth: 'lg', mt: '12px' }}
        variant="fullWidth"
        value={TabValues.indexOf(selectedTab)}
        onChange={handleChange}
      >
        <Tab variant="tab" label={t('activityManagement.tabActivities')} />
        <Tab variant="tab" label={t('activityManagement.tabFindings')} />
      </Tabs>
      {findingsLoadStatus === LoadStatus.SUCCESS &&
        activityLoadStatus === LoadStatus.SUCCESS &&
        renderTabContents(selectedTab)}
      {(findingsLoadStatus === LoadStatus.IN_PROGRESS || activityLoadStatus === LoadStatus.IN_PROGRESS) && (
        <LoadingIndicator />
      )}
    </Container>
  );
}

export default ManageActivitiesView;
